import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsInChat } from 'selectors/location'
import { isMac } from 'util/browser'
import HotkeysGroup from './HotkeysGroup'

const inboxActions = {
  r: 'Reply',
  f: 'Forward',
  n: 'Note',
  i: 'Insert canned reply',
  "'": 'Toggle right sidebar',
  ';': 'Expand all replies',
  ':': 'Collapsed all replies',
  [`${isMac() ? 'cmd' : 'ctrl'}+enter`]: 'Send',
}

const chatActions = {
  r: 'Reply',
  n: 'Note',
  "'": 'Toggle right sidebar',
  enter: 'Send',
}

export default function Conversation() {
  const isInChat = useSelector(selectIsInChat)
  return (
    <HotkeysGroup
      title="Conversation"
      hotkeys={isInChat ? chatActions : inboxActions}
    />
  )
}
